var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackLinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33332 7.5H4.83332C3.41666 7.5 2.33332 6.41667 2.33332 5C2.33332 3.58333 3.41666 2.5 4.83332 2.5H7.33332C7.83332 2.5 8.16666 2.16667 8.16666 1.66667C8.16666 1.16667 7.83332 0.833334 7.33332 0.833334H4.83332C2.49999 0.833334 0.666656 2.66667 0.666656 5C0.666656 7.33333 2.49999 9.16667 4.83332 9.16667H7.33332C7.83332 9.16667 8.16666 8.83333 8.16666 8.33333C8.16666 7.83333 7.83332 7.5 7.33332 7.5ZM13.1667 0.833334H10.6667C10.1667 0.833334 9.83332 1.16667 9.83332 1.66667C9.83332 2.16667 10.1667 2.5 10.6667 2.5H13.1667C14.5833 2.5 15.6667 3.58333 15.6667 5C15.6667 6.41667 14.5833 7.5 13.1667 7.5H10.6667C10.1667 7.5 9.83332 7.83333 9.83332 8.33333C9.83332 8.83333 10.1667 9.16667 10.6667 9.16667H13.1667C15.5 9.16667 17.3333 7.33333 17.3333 5C17.3333 2.66667 15.5 0.833334 13.1667 0.833334ZM5.66666 5C5.66666 5.5 5.99999 5.83333 6.49999 5.83333H11.5C12 5.83333 12.3333 5.5 12.3333 5C12.3333 4.5 12 4.16667 11.5 4.16667H6.49999C5.99999 4.16667 5.66666 4.5 5.66666 5Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackLinks);
export default __webpack_public_path__ + "static/media/BackLinks.04b0478b.svg";
export { ForwardRef as ReactComponent };